module.exports = __webpack_public_path__ + "img/zones.300bf991.png";